import axios from 'axios'
import router from '@/router'
import store from '@/store'
import logger from '@/utils/logger'

const createAxiosInstance = () => {
  const axiosInstance = axios.create({ withCredentials: true })

  axiosInstance.interceptors.request.use(
    (config) => {
      if (store.getters.accessToken) {
        // AccessTokenがある場合ヘッダーに付ける（パスワード認証している場合）
        config.headers['Authorization'] = `Bearer ${store.getters.accessToken}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      logger.error(error)
      const path = router.currentRoute.path
      if (
        error.response &&
        error.response.status === 401 &&
        path !== '/' &&
        path !== '/login'
      ) {
        store.dispatch('clearUserInfo')
        router.push('/session-expired')
      }

      return Promise.reject(error)
    }
  )
  return axiosInstance
}

// 設定済みのインスタンスを作成してエクスポート *各baseURLはmain.jsで設定
const axiosCredentials = createAxiosInstance()
export { axiosCredentials }
